import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"success\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM5.59473 11.2292L6.8084 10.0535C8.7368 11.5994 9.6973 12.377 9.6898 12.3864C11.6959 9.8817 14.1269 7.7128 16.9828 5.87988C17.2518 6.3505 17.3744 6.5966 17.3504 6.6184C14.3509 9.3385 12.0751 12.5378 10.5228 16.2161L5.59473 11.2292Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol